import { render, staticRenderFns } from "./NarocilaSelectable.vue?vue&type=template&id=1db5c918&"
import script from "./NarocilaSelectable.vue?vue&type=script&lang=js&"
export * from "./NarocilaSelectable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports